module.exports = __webpack_public_path__ + "img/DMS_logo.7133c2e9.png";